require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-ifc-remedy-framework-and-responsible-exit-principles.json") })
        }
      }, "path---en-us-update-ifc-remedy-framework-and-responsible-exit-principles");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-ifc-remedy-framework-and-responsible-exit-principles!./.cache/json/en-us-update-ifc-remedy-framework-and-responsible-exit-principles.json
// module id = 755
// module chunks = 231608221292675